module.exports = __webpack_public_path__ + "static/media/11_2.1d0853e2.jpg";